import {createContext} from 'react';

/**
 * Transactions
 */
export const TransactionsContext = createContext({});
